import { Col, Modal, Row, Container, Form } from "react-bootstrap";
import React, { useState, useMemo } from "react";

const ViewFacilitiesModal = ({ show, setShow, facilities }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const data = facilities || [];
  const facilityList = JSON.parse(localStorage.getItem("facilitiesData")) || [];

  // Build lookup map
  const facilityObj = facilityList.reduce((obj, item) => {
    obj[item.value] = item.key;
    return obj;
  }, {});

  // Sort alphabetically and filter by search
  const filteredData = useMemo(() => {
    const list = data
      .map((id) => ({
        id,
        name: facilityObj[id] || "",
      }))
      .filter((f) =>
        f.name.toLowerCase().includes(searchQuery.toLowerCase().trim())
      )
      .sort((a, b) => a.name.localeCompare(b.name));

    return list;
  }, [data, facilityObj, searchQuery]);

  // Determine number of columns dynamically
  let numCols = 1;
  if (filteredData.length > 12) numCols = 3;
  else if (filteredData.length > 6) numCols = 2;

  const itemsPerCol = Math.ceil(filteredData.length / numCols);
  const columns = Array.from({ length: numCols }, (_, i) =>
    filteredData.slice(i * itemsPerCol, (i + 1) * itemsPerCol)
  );

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      size="xl"
      centered
      scrollable
    >
      <Modal.Header closeButton className="bg-light">
        <Modal.Title as="h5" className="fw-bold text-primary">
          Assigned Facilities
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        className="bg-white hide-scrollbar"
        style={{
          maxHeight: "70vh",
          overflowY: "auto",
          padding: "24px 32px",
        }}
      >
        <Container fluid>
          {/* Search Bar */}
          <Form.Control
            type="text"
            placeholder="Search facility..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="mb-4"
            style={{
              borderRadius: "10px",
              border: "1px solid #ced4da",
              padding: "10px 14px",
              fontSize: "0.95rem",
            }}
          />

          {filteredData.length > 0 ? (
            <Row
              className="g-4"
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent:
                  numCols === 1
                    ? "center"
                    : numCols === 2
                    ? "space-evenly"
                    : "space-between",
              }}
            >
              {columns.map((colItems, idx) => (
                <Col
                  key={idx}
                  xs={12}
                  md={numCols === 3 ? 4 : numCols === 2 ? 6 : 12}
                  className="d-flex flex-column align-items-start"
                >
                  {colItems.map((f, i) => (
                    <div
                      key={i}
                      style={{
                        background: "#f9fafb",
                        borderRadius: "8px",
                        padding: "8px 14px",
                        marginBottom: "10px",
                        width: "100%",
                        boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
                        transition: "transform 0.2s ease",
                      }}
                    >
                      <p
                        className="fw-semibold mb-0 text-secondary"
                        style={{
                          fontSize: "0.95rem",
                          lineHeight: "1.4",
                          wordBreak: "break-word",
                        }}
                      >
                        {f.name}
                      </p>
                    </div>
                  ))}
                </Col>
              ))}
            </Row>
          ) : (
            <Row>
              <Col className="fw-bold text-center text-muted">
                No facilities found
              </Col>
            </Row>
          )}
        </Container>
      </Modal.Body>
      <style>
        {`
          .hide-scrollbar::-webkit-scrollbar {
            width: 0px;
            height: 0px;
          }
          .hide-scrollbar {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
        `}
      </style>
    </Modal>
  );
};

export default ViewFacilitiesModal;